module.exports = __webpack_public_path__ + "img/bluesky3100_11.c9a81f4c.jpg";